import { render, staticRenderFns } from "./StandardCarousel.vue?vue&type=template&id=47863e13"
import script from "./StandardCarousel.vue?vue&type=script&lang=js"
export * from "./StandardCarousel.vue?vue&type=script&lang=js"
import style0 from "./StandardCarousel.vue?vue&type=style&index=0&id=47863e13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports